import {Component, Input, OnInit} from '@angular/core';
import {ConnectionType, DataType, MeterType} from "@flowmaps-com/flowmaps-typescriptmodels";
import {Entity, EntityType} from "../../../handlers/entity";
import {DataQueryFilters} from "../../measurements-component/measurements-handler.component";
import {View} from "../../../common/view";

@Component({
    selector: 'app-meter-dashboard',
    templateUrl: './meter-dashboard.component.html',
    styleUrls: ['./meter-dashboard.component.scss']
})
export class MeterDashboardComponent extends View  implements OnInit {
    @Input() meterEntities: Entity[] = [];
    availableConnectionTypes: ConnectionType[] = [];
    filters: DataQueryFilters;
    onlyConnectionSelected: boolean = false;

    ngOnInit() {
        this.subscribeTo("getChartDataQueryFilters")
            .subscribe((f: DataQueryFilters) => {
                this.filters = f;
                const types = ((f?.allSelectedSources?.length ? f.allSelectedSources : f?.sources) || [])
                    .map(s => s.connectionType).filter(t => t);
                this.availableConnectionTypes = Array.from(new Set(types));
                const sources = f?.cleanedSources?.length ? f.cleanedSources : f.sources || [];
                this.onlyConnectionSelected = sources.length > 0 && sources.every(s => s.type === EntityType.connection);
            });
    }

    meterLocation = () => {
        const meters = (this.filters.allSelectedSources || []).filter(s => s.type === EntityType.meter);
        if (!meters.length) return null;
        const location = meters[0].source?.location;
        return meters.every(m => m.source?.location?.locationId === location?.locationId) ? location : null;
    };

    showChart(type: any): boolean {
        return type === ConnectionType.Gas
            ? this.availableConnectionTypes.some(t => [ConnectionType.Gas, ConnectionType.Heat, ConnectionType.Cooling].includes(t))
            : (this.availableConnectionTypes || []).includes(type as ConnectionType);
    }

    defaultMeasurement(type: any) {
        const sources = this.filters?.allSelectedSources?.length
            ? this.filters.allSelectedSources : this.filters?.sources || [];
        const meters = sources.filter(source => source.type === EntityType.meter && source.connectionType === type);
        // The source type determines the measurement channel, independently of display-role overrides.
        const primaryOnly = meters.length > 0 && meters.every(source =>
            source.source?.meter?.info?.type === MeterType.PRIMARY);
        switch (type as ConnectionType) {
            case ConnectionType.Electricity:
                return primaryOnly ? DataType.electricityConsumption : DataType.electricityIntermediateConsumption;
            case ConnectionType.Water:
                return primaryOnly ? DataType.waterConsumption : DataType.waterIntermediateConsumption;
            case ConnectionType.ChargePoint:
                return primaryOnly ? DataType.chargePointConsumption : DataType.chargePointIntermediateConsumption;
            case ConnectionType.Gas:
                return this.availableConnectionTypes.includes(ConnectionType.Gas) ? DataType.gasConsumption
                    : this.availableConnectionTypes.includes(ConnectionType.Heat) ? DataType.heatConsumption
                        : DataType.coolingConsumption;
        }
    }
}
